import script from "./MobileShopHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileShopHeader.vue?vue&type=script&setup=true&lang=js"

import "./MobileShopHeader.vue?vue&type=style&index=0&id=41d037af&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d037af"]])

export default __exports__